import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import urlConstants from './constants/urlConstants';
import ScrollToTop from './components/ScrollToTop';
import ExternalRedirect from './components/ExternalRedirect';
import {
  KeuzePage,
  HomePage,
  WatWeDoenPage,
  WieWeZijnPage,
  ReviewsPage,
  VragenPage,
  VoorScholenPage,
  GedragscodePage,
  ContactPage,
  InschrijvenVoorlichtingPage,
  InschrijvenTrainingPage,
  DataPage,
  PrivacyStatementPage,
  AlgemeneVoorwaardenPage,
} from './pages';

function App() {
  return (
    <Router>
      <>
        <ScrollToTop />
        <Switch>
          <Route exact path={urlConstants.HOME}>
            <KeuzePage />
          </Route>
          <Route exact path={urlConstants.HOME_EN}>
            <KeuzePage lang="en" />
          </Route>
          <Route exact path={urlConstants.JONGEREN}>
            <HomePage />
          </Route>
          <Route path={urlConstants.WATWEDOEN}>
            <WatWeDoenPage />
          </Route>
          <Route path={urlConstants.WIEWEZIJN}>
            <WieWeZijnPage />
          </Route>
          <Route path={urlConstants.RESULTATEN}>
            <ReviewsPage />
          </Route>
          <Route path={urlConstants.VRAGEN}>
            <VragenPage />
          </Route>
          <Route exact path={urlConstants.OPVOEDERS}>
            <ExternalRedirect to={urlConstants.OPVOEDERS_SITE} />
          </Route>
          <Route exact path={urlConstants.SCHOLEN}>
            <VoorScholenPage />
          </Route>
          <Route exact path={urlConstants.VOLWASSENEN}>
            <ExternalRedirect to={urlConstants.JONGVOLWASSENEN_SITE} />
          </Route>
          <Route path={urlConstants.YOUNGLEADERS}>
            <ExternalRedirect to={urlConstants.JONGVOLWASSENEN_SITE} />
          </Route>
          <Route path={urlConstants.GEDRAGSCODE}>
            <GedragscodePage />
          </Route>
          <Route path={urlConstants.CONTACT}>
            <ContactPage />
          </Route>
          <Route exact path={urlConstants.VOORLICHTING}>
            <InschrijvenVoorlichtingPage />
          </Route>
          <Route exact path={urlConstants.TRAINING}>
            <InschrijvenTrainingPage />
          </Route>
          <Route exact path={urlConstants.DATA}>
            <DataPage />
          </Route>
          <Route path={urlConstants.PRIVACY}>
            <PrivacyStatementPage />
          </Route>
          <Route path={urlConstants.VOORWAARDEN}>
            <AlgemeneVoorwaardenPage />
          </Route>
          <Route>
            <Redirect to={urlConstants.HOME} />
          </Route>
        </Switch>
      </>
    </Router>
  );
}

export default App;
